import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshancabs() {



  const cardData =
  {
    keyword: 'Pune to Konkan Darshan Cabs Hire',
    heading: 'Sai Trupti Cabs: Pune to Konkan Darshan Cabs Hire',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Konkan Darshan cab hire services, designed to make your scenic road-trip along the Western Ghats and coastal towns of the Konkan smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors, ample luggage space and ideal for stopping at the beaches, forts and ghats of Konkan. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way through your Konkan sightseeing. With transparent one-way or multi-day package fares, flexible booking options (one-way, round-trip or custom itinerary), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Konkan Darshan convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Konkan with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is one of Konkan’s most pristine and spiritually uplifting destinations, famous for its long stretch of golden sands and the revered Swayambhu Ganpati Temple. The turquoise Arabian Sea, rhythmic waves, and palm-fringed coastlines create a picture-perfect landscape. Pilgrims visit to seek blessings from Lord Ganesha whose self-manifested idol faces the sea, symbolizing harmony between nature and divinity. The beach also offers water sports, horse rides, and mesmerizing sunsets. Whether you’re a devotee, a traveler, or a photographer, Ganpatipule’s serenity and natural beauty promise a divine coastal escape."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach, located near Malvan, is Konkan’s jewel of crystal-clear waters and adventure. Famous for scuba diving and snorkeling, it offers a rare glimpse of coral reefs, colorful fish, and marine life. The white sandy beach merges seamlessly with the emerald-blue sea, while houseboats along the Karli River add a backwater charm reminiscent of Kerala. Visitors can enjoy parasailing, banana rides, and dolphin spotting trips. With its laid-back atmosphere and coastal homestays serving Malvani cuisine, Tarkarli captures the essence of Konkan — untouched, authentic, and endlessly captivating."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort stands proudly off the coast of Malvan, a majestic sea fort built by Chhatrapati Shivaji Maharaj in the 17th century. Constructed with massive stones and surrounded by the Arabian Sea, it was designed to be an impregnable naval stronghold. Visitors reach the fort by boat and explore its hidden passageways, freshwater wells, and ancient shrines — including one dedicated to Shivaji himself. The panoramic view of the coastline from its ramparts is breathtaking. Sindhudurg Fort isn’t just a monument — it’s a living testament to the valor, strategy, and maritime vision of the Maratha Empire."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is the gateway to the Konkan coast — a charming seaside town known for its beaches, forts, and laid-back atmosphere. Just a short ferry ride from Mumbai, it’s a favorite weekend getaway offering beaches like Varsoli, Nagaon, and Kashid, all framed by swaying palms. The Kolaba Fort, accessible during low tide, adds a historical twist to this coastal paradise. Alibaug also offers luxurious resorts, cozy homestays, and water sports. Whether you seek history, relaxation, or adventure, Alibaug combines them all effortlessly with a touch of island serenity."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort is a remarkable sea fortress built on an island off the Murud coast, standing unconquered for over 300 years. Constructed by the Siddis, this massive fort rises majestically from the sea with 19 rounded bastions still intact. Accessible only by boat, it offers awe-inspiring views of the ocean and nearby Murud Beach. Inside, visitors can see ancient cannons, palaces, and freshwater ponds that sustained inhabitants for centuries. The combination of historical intrigue and coastal beauty makes Murud-Janjira one of Konkan’s most extraordinary and photogenic attractions."
  },
  {
    "title": "Ratnagiri",
    "description": "Ratnagiri is the cultural and historical heart of Konkan, blessed with beaches, forts, and mango orchards. The city is famous for its Alphonso mangoes, known worldwide for their sweetness and aroma. Landmarks like Ratnadurg Fort, Thibaw Palace, and Bhatye Beach showcase a perfect blend of history and nature. Visitors can stroll through the tranquil Ganeshghule Beach or visit the marine museum. During the monsoon, Ratnagiri transforms into a lush green paradise with waterfalls cascading down the hills. It’s a destination where heritage, flavor, and scenic charm come together beautifully."
  },
  {
    "title": "Velneshwar Beach",
    "description": "Velneshwar Beach is a hidden gem in Konkan, known for its crescent-shaped shoreline and crystal-clear waters. Unlike busier beaches, Velneshwar offers solitude, clean sands, and a peaceful ambiance ideal for swimming or relaxation. The ancient Shiva temple nearby adds a spiritual aura to the location. Coconut groves line the shore, creating postcard-perfect views during sunrise and sunset. Every February, the Maha Shivratri festival fills the area with music, devotion, and joy. For those seeking a tranquil coastal retreat, Velneshwar is Konkan’s quiet treasure."
  },
  {
    "title": "Guhagar",
    "description": "Guhagar, nestled between the Vashishti River and the Arabian Sea, is one of Konkan’s most serene beach towns. The beach stretches endlessly with fine white sand, making it ideal for long walks, picnics, and beach games. The town is dotted with temples like Vyadeshwar and Durga Devi, adding spiritual charm. Local eateries serve authentic Konkani thalis featuring fresh seafood and coconut curries. Guhagar’s simplicity, untouched beauty, and warm locals give travelers a taste of traditional coastal Maharashtra at its finest."
  },
  {
    "title": "Diveagar Beach",
    "description": "Diveagar Beach is a scenic blend of spirituality and serenity, located in Raigad district. The golden sands and gentle waves attract both families and solo travelers looking to unwind. The village is also home to the famous Suvarna Ganesh Temple, where a golden idol of Lord Ganesha was once discovered. Coconut and betel nut plantations surround the area, adding to its tropical charm. Water sports, birdwatching, and dolphin rides make it a perfect all-round coastal destination. Diveagar’s peaceful rhythm reflects the soul of Konkan — calm, divine, and eternally welcoming."
  },
  {
    "title": "Hedvi Beach & Dashabhuja Ganpati Temple",
    "description": "Hedvi is a quiet coastal village located near Guhagar, known for its black sand beach and the revered Dashabhuja Ganpati Temple. The temple’s idol depicts Lord Ganesha with ten arms and is believed to grant blessings for prosperity and peace. Nearby, the ‘Bamanghal’ gorge offers a unique geological wonder where sea waves crash dramatically through narrow rock formations. The combination of natural beauty, divine energy, and rustic charm makes Hedvi a soulful stop on any Konkan tour. It’s the perfect blend of faith, landscape, and local culture."
  }
],



"services": [
  {
    "name": "Pune to Konkan Darshan Cabs Hire",
    "description": "Book cabs from Pune to Konkan for sightseeing and leisure trips. Offers AC/non-AC options, professional drivers, luggage support, flexible schedules, and comfortable rides. Ideal for families, groups, and tourists exploring Konkan."
  },
  {
    "name": "Pune to Konkan Taxi Service",
    "description": "Reliable taxi service from Pune to Konkan with well-maintained vehicles, punctual pickups, AC/non-AC options, professional chauffeurs, and luggage assistance. Perfect for safe, hassle-free long-distance travel."
  },
  {
    "name": "Pune to Konkan Car Hire",
    "description": "Hire a car from Pune to Konkan with sedans, SUVs, and premium vehicles. Provides AC/non-AC options, professional drivers, ample luggage space, flexible pickup/drop schedules, and comfortable rides for family or group travel."
  },
  {
    "name": "Pune to Konkan AC Cab",
    "description": "Travel comfortably in AC cabs from Pune to Konkan with professional drivers, luggage support, flexible pickup/drop points, and well-maintained vehicles. Ideal for families, groups, and corporate travelers."
  },
  {
    "name": "Pune to Konkan Non AC Cab",
    "description": "Budget-friendly non-AC cab service from Pune to Konkan with reliable vehicles, professional drivers, luggage assistance, and flexible schedules. Perfect for economical travel without compromising safety and comfort."
  },
  {
    "name": "Pune to Konkan Innova Cab",
    "description": "Spacious Innova cab service from Pune to Konkan with AC/non-AC options, professional drivers, luggage support, and flexible schedules. Perfect for family trips or group travel seeking comfort and convenience."
  },
  {
    "name": "Pune to Konkan Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune to Konkan offering AC/non-AC options, professional chauffeurs, luggage support, and ample seating for small families or groups for a smooth and enjoyable journey."
  },
  {
    "name": "Luxury Cab Pune to Konkan",
    "description": "Premium luxury cab service from Pune to Konkan with AC comfort, elegant interiors, professional drivers, luggage assistance, and timely pickups. Ideal for VIP travel, weddings, and special occasions."
  },
  {
    "name": "Affordable Pune to Konkan Cab",
    "description": "Economical cab service from Pune to Konkan offering AC/non-AC options, professional drivers, luggage support, flexible schedules, and transparent fares. Perfect for budget-conscious travelers seeking comfort and reliability."
  },
  {
    "name": "Pune to Konkan Outstation Cab",
    "description": "Outstation cab service from Pune to Konkan with AC/non-AC options, professional drivers, luggage support, flexible schedules, and online booking for hassle-free long-distance travel and sightseeing trips."
  },
  {
    "name": "Pune to Konkan One Way Cab",
    "description": "Convenient one-way cab service from Pune to Konkan with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop points for economical and comfortable travel."
  },
  {
    "name": "Pune to Konkan Drop Cab",
    "description": "Safe and punctual drop cab service from Pune to Konkan with AC/non-AC vehicles, professional drivers, luggage support, and flexible scheduling for stress-free journeys."
  },
  {
    "name": "Pune to Konkan Corporate Cab",
    "description": "Corporate cab service from Pune to Konkan with AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and reliable service for business trips, meetings, and corporate outings."
  },
  {
    "name": "Pune to Konkan Wedding Cab",
    "description": "Elegant wedding cab service from Pune to Konkan with luxury vehicles, AC comfort, professional chauffeurs, luggage assistance, and timely pickups for weddings, family events, and special occasions."
  },
  {
    "name": "Pune to Konkan Online Booking",
    "description": "Book your Pune to Konkan cab online instantly with AC/non-AC options, professional drivers, flexible pickup/drop points, secure payments, and transparent fares for convenient and hassle-free travel."
  }
],
"tableData": [
  ["Pune to Konkan Darshan Cabs Hire", "Pune to Konkan Taxi Service"],
  ["Pune to Konkan Car Hire", "Pune to Konkan AC Cab"],
  ["Pune to Konkan Non AC Cab", "Pune to Konkan Innova Cab"],
  ["Pune to Konkan Ertiga Cab", "Luxury Cab Pune to Konkan"],
  ["Affordable Pune to Konkan Cab", "Pune to Konkan Outstation Cab"],
  ["Pune to Konkan One Way Cab", "Pune to Konkan Drop Cab"],
  ["Pune to Konkan Corporate Cab", "Pune to Konkan Wedding Cab"],
  ["Pune to Konkan Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Konkan Darshan Cabs Hire",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Konkan — perfect for scenic road trips, weekend getaways, and cultural tours."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Konkan cabs, starting at affordable rates depending on vehicle type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for your Konkan Darshan journey."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Konkan route, ensuring a safe, smooth, and timely trip along scenic coastal roads."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at any location across the Konkan region, including beaches, resorts, or towns."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your leisure or sightseeing trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Konkan Darshan cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]




























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Konkan Darshan cab hire services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Konkan Darshan cab hire services for family trips, group tours, and weekend getaways.',
  },
  {
    question: 'How can I hire a cab from Pune to Konkan Darshan with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Konkan Darshan cab through our website, mobile app, or by contacting our 24×7 customer support team for quick assistance.',
  },
  {
    question: 'What types of cabs are available for Pune to Konkan Darshan?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your group size, comfort preference, and budget for Konkan Darshan tours.',
  },
  {
    question: 'Are the drivers experienced for Pune to Konkan Darshan trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving through the Konkan region’s coastal routes, ensuring a safe and pleasant journey.',
  },
  {
    question: 'Can I book a cab for sightseeing and multiple stops in the Konkan region?',
    answer: 'Certainly. You can customize your Konkan Darshan cab itinerary to include multiple sightseeing destinations such as Ganpatipule, Ratnagiri, Tarkarli, and Alibaug.',
  },
  {
    question: 'Is the Pune to Konkan Darshan cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Konkan Darshan trips to accommodate your travel schedule and convenience.',
  },
  {
    question: 'What are the Pune to Konkan Darshan cab fares?',
    answer: 'Our cab fares for Pune to Konkan Darshan start from approximately ₹4,500 for sedans and ₹6,500–₹9,000 for SUVs or tempo travellers, depending on the vehicle type, route, and duration of the trip.',
  },
  {
    question: 'What payment options are accepted for Pune to Konkan Darshan cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Konkan Darshan cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure a secure and comfortable travel experience.',
  },
  {
    question: 'Is customer support available during the Pune to Konkan Darshan cab trip?',
    answer: 'Yes, our 24×7 customer support team is always available to assist you throughout your Pune to Konkan Darshan cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Deshmukh',
    feedback: 'We hired a cab from Sai Trupti Cabs for our Pune to Konkan Darshan trip. The experience was excellent—clean car, punctual driver, and comfortable journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Naik',
    feedback: 'Sai Trupti Cabs made our Konkan Darshan trip memorable. The driver was professional and helped us explore all the major Konkan attractions smoothly.',
    rating: 5,
  },
];





















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cabs Hire",
  "image": "https://saitrupticabs.com/assets/images/pune-to-konkan-darshan-cabs.jpg",
  "description": "Book cabs from Pune to Konkan Darshan for sightseeing, corporate trips, weddings, or outstation travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-konkan-darshan-cabs-hire"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Konkan Darshan Cabs Hire | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Konkan Darshan for sightseeing, corporate trips, weddings, or outstation travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Konkan Darshan Cabs Hire, Pune to Konkan Taxi Service, Pune to Konkan Car Hire, Pune to Konkan AC Cab, Pune to Konkan Non AC Cab, Pune to Konkan Innova Cab, Pune to Konkan Ertiga Cab, Luxury Cab Pune to Konkan, Affordable Pune to Konkan Cab, Pune to Konkan Outstation Cab, Pune to Konkan One Way Cab, Pune to Konkan Drop Cab, Pune to Konkan Corporate Cab, Pune to Konkan Wedding Cab, Pune to Konkan Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkandarshancabs;